export default __webpack_public_path__ + "static/media/goa.2267e5e3.png";